import React, { useState } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next/';

import PreprUtil from '@utils/PreprUtil';
import { useAdvertisement, useLocale } from '@hooks/index';
import { ADVERTISEMENT_DEVICE, ADVERTISEMENT_TYPE, IMAGE_SIZES } from '@constants/enums';

import styles from './TopListAllPage.module.scss';
import Props from './TopListAllPage.props';
import { Meta } from '@components/layout/Meta/Meta';
import LoginModal from '@components/modals/LoginModal/LoginModal';
import RegisterModal from '@components/modals/RegisterModal/RegisterModal';
import Button from '@components/ui/Button/Button';
import PrimaryHeader from '@components/ui/PrimaryHeader/PrimaryHeader';
import TipListItem from '@components/ui/TipListItem/TipListItem';

const TopListAllPage = ({ className, fields }: Props) => {
  useAdvertisement(
    ADVERTISEMENT_TYPE.ARTICLE,
    ADVERTISEMENT_DEVICE.DESKTOP_AND_MOBILE,
    `.${styles.Content} a`,
    4,
  );
  useAdvertisement(
    ADVERTISEMENT_TYPE.ARTICLE,
    ADVERTISEMENT_DEVICE.DESKTOP_AND_MOBILE,
    `.${styles.Content} a`,
    11,
  );
  useAdvertisement(
    ADVERTISEMENT_TYPE.ARTICLE,
    ADVERTISEMENT_DEVICE.DESKTOP_AND_MOBILE,
    `.${styles.Content} a`,
    16,
  );
  const { t } = useTranslation();
  const locale = useLocale();
  const [renderAmount, setRenderAmount] = useState(25);
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);
  const isDP = locale === 'nl-NL';

  const handleRegisterClick = () => {
    setLoginModalOpen(false);
    setRegisterModalOpen(true);
  };

  const handleLoadMore = () => {
    setRenderAmount(renderAmount + 25);
  };

  const orderedItems = fields.items?.sort((a, b) => {
    if (!isDP) {
      if (a._likes === null) return 1;
      if (b._likes === null) return -1;
      return b._likes - a._likes;
    }

    if (a._bookmarks === null) return 1;
    if (b._bookmarks === null) return -1;
    return b._bookmarks - a._bookmarks;
  });

  const renderTipList = () => {
    return orderedItems
      .slice(0, renderAmount)
      .map((item) => (
        <TipListItem
          key={item._id}
          className="mb-4"
          tip={PreprUtil.formatToListItemProps(item, undefined, undefined, IMAGE_SIZES.FULL)}
          onUnauthorizedAdd={() => setLoginModalOpen(true)}
        />
      ));
  };

  return (
    <>
      <Meta
        title={fields.meta_title || fields.title}
        description={fields.meta_description || fields.subtitle}
        image={fields.thumbnail?.[0]?.cdn_files[0]?.full}
      />
      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setLoginModalOpen(false)}
        onRegisterClick={handleRegisterClick}
      />
      <RegisterModal isOpen={isRegisterModalOpen} onClose={() => setRegisterModalOpen(false)} />
      <div className={cn(styles.TopListAllPage, className)}>
        <PrimaryHeader
          backgroundImage={fields.thumbnail[0]?.cdn_files[0]?.full}
          title={t('DOMAIN.BUCKETLIST.TOP_X_LIST', { total: fields.items.length })}
          description={fields.subtitle}
        />
        <div className="container">
          <div className={styles.Content}>
            <ul>{renderTipList()}</ul>
            <Button iconPosition="left" onPress={handleLoadMore} className={styles.Button}>
              {t('DOMAIN.BUCKETLIST.LOAD_MORE')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopListAllPage;
